// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2304":"545ae599","2885":"2b459199","8920":"2b459199","9437":"a4b56985"}[chunkId] + ".css";
};